import { createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice";

//get some normalized state
//work data that has an ids array and then also has entities
const notesAdapter = createEntityAdapter({
  //try to put completed note into bottom
  //true values first
  //sortComparer: (a, b) => a.pinned === b.pinned ? 0 : a.pinned ? -1 : 1,
  // false values first
  // a.pinned === b.pinned ? 0 : x? 1 : -1
  //sortComparer: (a, b) => (a.updatedAt > b.updateAt ? 0 : a.updatedAt ? -1 : 1),
  sortComparer: (a, b) =>
    a.pinned === b.pinned && a.updatedAt > b.updateAt
      ? 0
      : a.pinned && a.updatedAt
      ? -1
      : 1,
});
const initialState = notesAdapter.getInitialState();

//injection into original slice
//RTKQuery create an hook based on this endpoint for use
export const notesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getNotes: builder.query({
      query: () => ({
        url: "/notes",
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError; //make sure isn't error
        },
      }),
      //keepUnusedDataFor: 5, //5s => when production change to 60s(default)
      //useful when work with backend
      transformResponse: (responseData) => {
        const loadedNotes = responseData.map((note) => {
          note.id = note._id;
          return note;
        });
        return notesAdapter.setAll(initialState, loadedNotes);
      },
      providesTags: (result, error, arg) => {
        //just fail safte
        if (result?.ids) {
          return [
            { type: "Note", id: "LIST" },
            ...result.ids.map((id) => ({ type: "Note", id })),
          ];
        } else return [{ type: "Note", id: "LIST" }];
      },
      //providesTags: [{ type: "Note", id: "LIST" }],
    }),
    addNewNote: builder.mutation({
      query: (initialNote) => ({
        url: "/notes",
        method: "POST",
        body: {
          ...initialNote,
        },
      }),
      invalidatesTags: [{ type: "Note", id: "LIST" }],
    }),
    updateNote: builder.mutation({
      query: ({ id, initialNote }) => ({
        url: `/notes/${id}`,
        method: "PUT",
        body: {
          ...initialNote,
        },
      }),
      invalidatesTags: (result, error, arg) => [{ type: "Note", id: arg.id }],
    }),
    deleteNote: builder.mutation({
      query: ({ id }) => ({
        url: `/notes/${id}`,
        method: "DELETE",
        //body: { id },
      }),
      invalidatesTags: (result, error, arg) => [{ type: "Note", id: arg.id }],
    }),
  }),
});

export const {
  useGetNotesQuery,
  useAddNewNoteMutation,
  useUpdateNoteMutation,
  useDeleteNoteMutation,
} = notesApiSlice;

// returns the query result object
export const selectNotesResult = notesApiSlice.endpoints.getNotes.select();

// creates memoized selector
const selectNotesData = createSelector(
  selectNotesResult,
  (notesResult) => notesResult.data // normalized state object with ids & entities
);

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
  selectAll: selectAllNotes,
  selectById: selectNoteById,
  selectIds: selectNoteIds,
  // Pass in a selector that returns the notes slice of state
  //?? : return the right hand value if left hand value is undefined and null
} = notesAdapter.getSelectors(
  (state) => selectNotesData(state) ?? initialState
);
